import React from 'react';
import ObjectField from 'react-jsonschema-form/lib/components/fields/ObjectField';
import {retrieveSchema} from 'react-jsonschema-form/lib/utils';
import {Col} from 'react-bootstrap';
import {Button} from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

export default class GridField extends ObjectField {
  state = {firstName: 'hasldf'};

  render() {
    const {
      uiSchema,
      errorSchema,
      idSchema,
      required,
      disabled,
      readonly,
      onBlur,
      formData,
    } = this.props;
    const {definitions, fields, formContext} = this.props.registry;
    const {SchemaField, TitleField, DescriptionField} = fields;
    const schema = retrieveSchema(this.props.schema, definitions);
    const title = (schema.title === undefined) ? '' : schema.title;

    const layout = uiSchema['ui:layout'];
    
    return (
        <fieldset>
          {title ? <TitleField
              id={`${idSchema.$id}__title`}
              title={title}
              required={required}
              formContext={formContext} /> : null}
          {schema.description ? <DescriptionField
              id={`${idSchema.$id}__description`}
              description={schema.description}
              formContext={formContext} /> : null}
          {
            layout.map((row, index) => {
              let rowStyle = {};
              if (formContext.editMode) {
                rowStyle.border = '1px solid #f00';
                rowStyle.marginBottom = '2px';
                rowStyle.position = 'relative';
              }
              return (
                  <div className="row" key={index} style={rowStyle}
                  >
                    {
                      row.map((item, index) => {
                        const {name,doShow} = item;
                        const {...rowProps} = item.props;
                        let style = {};
                        if (doShow) { // && !doShow({formData})
                          style = {display: 'none'};
                        }
                        if (formContext.editMode) {
                          // style.border = '1px solid #00f';
                        }
                        if (schema.properties[name]) {
                          return (
                              <Col {...rowProps} key={index} style={style}>
                                <SchemaField
                                    name={name}
                                    required={this.isRequired(name)}
                                    schema={schema.properties[name]}
                                    uiSchema={uiSchema[name]}
                                    errorSchema={errorSchema[name]}
                                    idSchema={idSchema[name]}
                                    formData={formData[name]}
                                    onChange={this.onPropertyChange(name)}
                                    onBlur={onBlur}
                                    registry={this.props.registry}
                                    disabled={disabled}
                                    readonly={readonly} />
                              </Col>
                          );
                        } else {
                          if (name===undefined) {
                            return(
                              <Col {...rowProps} key={index} style={style}>
                                
                              </Col>
                            )
                          } else {
                            const {render, ...rowProps} = row[name];
                            let UIComponent = () => null;

                            if (render) {
                              UIComponent = render;
                            }

                            return (
                                <Col {...rowProps} key={index} style={style}>
                                  <UIComponent
                                      name={name}
                                      formData={formData}
                                      errorSchema={errorSchema}
                                      uiSchema={uiSchema}
                                      schema={schema}
                                      registry={this.props.registry}
                                  />
                                </Col>
                            );
                          }  
                        }
                      })
                    }
                    {formContext.editMode ? <div
                            style={{position: 'absolute', right: 0, bottom: 0}}>
                          {index > 0 ?
                              <div><Button bsStyle={'info'} bsSize={'xsmall'}
                                  title={'Move this row up'}
                                  onClick={formContext.onMoveRow(schema.group,
                                      index, -1)}>
                            <FontAwesome name={'arrow-up'} />
                              </Button>
                              </div> : ''}
                          {index < layout.length - 1 ? <div>
                          <Button bsStyle={'info'} bsSize={'xsmall'}
                                  title={'Move this row down'}
                                  onClick={formContext.onMoveRow(schema.group,
                                      index, 1)}>
                            <FontAwesome name={'arrow-down'} />
                          </Button>
                          </div> : ''}
                        </div>
                        : ''}
                  </div>
              );
            })
          }</fieldset>
    );
  }
}


// WEBPACK FOOTER //
// ./src/component/element/workdoc/layout/form-layout.js